import React from 'react'

const Newspaper = props => (
    <svg {...props}>
        <path d="M31 16H17v14h14V16zm-2 12H19V18h10v10zM52 16H36a1 1 0 100 2h16a1 1 0 100-2zM52 22H36a1 1 0 100 2h16a1 1 0 100-2zM52 28H36a1 1 0 100 2h16a1 1 0 100-2zM52 34H19a1 1 0 100 2h33a1 1 0 100-2zM34 40H19a1 1 0 100 2h15a1 1 0 100-2zM34 46H19a1 1 0 100 2h15a1 1 0 100-2zM34 52H19a1 1 0 100 2h15a1 1 0 100-2zM39 54h14V40H39v14zm2-12h10v10H41V42z"></path>
        <path d="M59 13c0-.017-.009-.031-.01-.048V0H11v30H1v24c0 3.309 2.691 6 6 6h46a5.997 5.997 0 005.99-5.99V13.048c.001-.017.01-.031.01-.048zM56.99 2v10H13V2h43.99zM3 54V32h8v22c0 2.206-1.794 4-4 4s-4-1.794-4-4zm50 4H11.469c.016-.018.027-.039.042-.057a5.961 5.961 0 00.634-.873c.162-.27.305-.552.423-.848l.045-.123a5.94 5.94 0 00.273-.949c.006-.03.008-.061.014-.09.062-.344.1-.698.1-1.06V14h43.99v40.01c0 2.2-1.79 3.99-3.99 3.99z"></path>
        <path d="M47 4H23v6h24V4zm-2 4H25V6h20v2z"></path>
    </svg>
)

export default Newspaper
